import store from '@/store'

export default [
  {
    path: '/',
    redirect: to => {
      // TODO: Redirect depend on role
      if (store.getters.loggedUser.role === 'admin') {
        return 'admin/defaults'
      } else {
        return 'business'
      }
    },
    component (resolve) {
      require(['@/views/root'], resolve)
    },
    children: [
      {
        path: 'login',
        component (resolve) {
          require(['@/views/login'], resolve)
        },
        meta: { allowAnonymous: true },
        beforeEnter: (to, from, next) => {
          if (localStorage.getItem('token')) {
            next('/')
          } else {
            next()
          }
        }
      },
      {
        path: 'business',
        component (resolve) {
          require(['@/views/business'], resolve)
        }
      },
      {
        path: 'business/:action/:id?',
        component (resolve) {
          require(['@/views/business/business'], resolve)
        }
      },
      // Admin
      {
        path: 'admin/defaults',
        component (resolve) {
          require(['@/views/admin/defaults'], resolve)
        }
      },
      {
        path: 'admin/salesreps',
        component (resolve) {
          require(['@/views/admin/sales-reps'], resolve)
        }
      }
    ]
  },
  {
    path: '*',
    component (resolve) {
      require(['@/views/error-pages/404'], resolve)
    },
    meta: { allowAnonymous: true }
  }
]



// WEBPACK FOOTER //
// ./src/router/routes.js